import { render, staticRenderFns } from "./ResetPasswordWithDialog.vue?vue&type=template&id=236b58ad&scoped=true&"
import script from "./ResetPasswordWithDialog.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordWithDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordWithDialog.vue?vue&type=style&index=0&id=236b58ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b58ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VDialog,VIcon})
